import type { VariantProps } from '@joyful/utils'
import { cn, tv } from '@joyful/utils'
import type { ComponentProps } from 'react'
import type { SetRequired } from 'type-fest'

export const headingVariants = tv({
  base: 'font-semibold leading-tight text-tremor-content-strong',

  defaultVariants: {
    margins: 'default',
  },

  variants: {
    level: {
      1: 'text-2xl/tight tracking-wide pb-1',
      2: 'text-2xl/tight tracking-wide pb-1',
      3: 'text-xl/tight tracking-wide',
      4: 'text-base/tight',
      5: 'text-sm/tight',
      6: 'text-[0.85rem]/tight text-tremor-content',
    },

    margins: {
      default: 'mt-6 mb-4',
      none: 'my-0',
    },
  },
})

interface HeadingProps
  extends
    ComponentProps<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>,
    SetRequired<VariantProps<typeof headingVariants>, 'level'> {}

export function Heading({ className, level, margins, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`

  return (
    <Element
      {...props}
      className={cn(
        headingVariants({
          level,
          margins,
        }),
        className,
      )}
    />
  )
}

export type SubheadingProps = ComponentProps<'h2'> &
  VariantProps<typeof headingVariants>

export function Subheading({
  className,
  level = 2,
  ...props
}: SubheadingProps) {
  const Element: `h${typeof level}` = `h${level}`

  return (
    <Element
      {...props}
      className={cn(
        'text-tremor-content-strong text-base/7 font-semibold sm:text-sm/6',
        className,
      )}
    />
  )
}
